import queryString from 'query-string';

export function debounce(fn, ms) {
  let to;

  function abort() {
    clearTimeout(to);
  }

  function func(...args) {
    const that = this;

    abort();

    to = setTimeout(
      function() {
        fn.apply(that, args);
      },
      ms
    );
  }

  func.abort = abort;

  return func;
}

export function normailzeQuery(query = '') {
  // Sometimes the query contains the app parameter two times (happened at least to one customer)
  // normalize the query-parameter.
  //return (query || '').replace('?app=Widget?app=Widget', '?app=Widget');
  if (query.match(/\?app=.*?\?/)) {
    return query.replace(/^\?app=.*?(\?.*)/, '$1');
  } else {
    return query;
  }
}

export function getContext() {
  return queryString.parse(normailzeQuery(window.location.search));
}

// taken from https://www.w3schools.com/Js/js_cookies.asp
export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/commons/services/utils.js